import { useState } from 'react';

/** Cierre de una ventana con formulario; se le pasa entero a `<Modal cierre={...}>`. */
export interface CierreConfirmado {
  /** Cierre con guarda: sin cambios cierra enseguida; con cambios sin guardar pide confirmación. */
  cerrar: () => void;
  /** true mientras la ventana muestra "Hay datos sin guardar. ¿Descartarlos?". */
  confirmando: boolean;
  seguirEditando: () => void;
  descartar: () => void;
}

/**
 * Guarda el cierre de un formulario con datos sin guardar. Usar `cerrar` para la ✕, Escape
 * (los dos vía `<Modal cierre>`) y los botones Cancelar/Cerrar del formulario. Al guardar con
 * éxito, llamar directamente a `onClose`: ese cierre no pregunta.
 */
export function useCierreConfirmado(sinGuardar: boolean, onClose: () => void): CierreConfirmado {
  const [confirmando, setConfirmando] = useState(false);
  // Si ya no hay cambios (se guardó o se cerró la ventana), la confirmación pendiente no aplica.
  if (confirmando && !sinGuardar) setConfirmando(false);

  return {
    cerrar: () => { if (sinGuardar) setConfirmando(true); else onClose(); },
    confirmando: confirmando && sinGuardar,
    seguirEditando: () => setConfirmando(false),
    descartar: () => { setConfirmando(false); onClose(); },
  };
}
